import type { Customer } from "@/mocks/admin/customers";

type Props = {
  customer: Customer;
  upcomingCount: number;
};

export default function KpiRow({ customer, upcomingCount }: Props) {
  const items = [
    {
      label: "Lifetime value",
      value: `$${customer.lifetimeValue.toLocaleString()}`,
      sub: customer.totalMoves > 0
        ? `over ${customer.totalMoves} ${customer.totalMoves === 1 ? "move" : "moves"}`
        : "no moves yet",
    },
    {
      label: "Completed moves",
      value: String(customer.totalMoves),
      sub:
        customer.lastMoveRelative ||
        (customer.lastMoveDate ? `last ${customer.lastMoveDate}` : "none yet"),
    },
    {
      label: "Upcoming",
      value: String(upcomingCount),
      sub: customer.nextBookingDate
        ? `next ${customer.nextBookingDate}`
        : "nothing scheduled",
    },
    {
      label: "Rating",
      value: customer.rating != null ? `${customer.rating}.0` : "—",
      sub: customer.rating != null ? "average across reviews" : "no reviews yet",
    },
  ];

  return (
    <div className="bg-white border border-ink-100 rounded-lg grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-ink-100">
      {items.map((it) => (
        <div key={it.label} className="px-5 py-4">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-bold">
            {it.label}
          </div>
          <div className="font-display text-xl md:text-2xl font-bold text-ink-900 mt-1 tabular-nums leading-tight">
            {it.value}
          </div>
          <div className="text-[11px] text-ink-500 mt-1 truncate">{it.sub}</div>
        </div>
      ))}
    </div>
  );
}